



































import Vue from 'vue';
import {RoutsData} from '@/router/routs';
import {VideoChannelApi} from '@/api/video-channel-api';
import {VideoChannel} from '@/types/video-channel';

let channelId: string;
export default Vue.extend({
  name: 'VideoChannel',
  created() {
    channelId = this.$route.params.channelId;
    if (channelId) {
      VideoChannelApi.getOne(channelId as string).then((res: any) => {
        this.channel = res.data;
      });
    }
  },
  data() {
    return {
      channel: new VideoChannel(this.$store.state.user.initiatorId),
      load: false
    };
  },
  computed: {
    isSave(): boolean {
      return channelId != undefined;
    }
  },
  methods: {
    onSave() {
      VideoChannelApi.save(this.channel).then(res => {
        this.$store.commit('setMessage', {
          show: true,
          text: 'Изменения сохранены'
        });

        this.channel = res.data;
        this.$router.push({name: RoutsData.VIDEO_CHANNEL.name, params: {channelId: res.data.id.toString()}});
      });
    }
  }
});
